import { Navigate, Outlet } from 'react-router-dom'
import { useAuth } from '@/modules/auth/hooks/useAuth'

export const AdminRoute = () => {
  const { isAuthenticated, isAdmin } = useAuth()

  if (!isAuthenticated || !isAdmin) {
    return <Navigate to="/" replace />
  }

  return <Outlet />
}
